import { Box, DialogTitle, Divider, Typography, styled } from "@mui/material"
import { useSsoService } from "../../../../hooks"
import { SecurityDialogIcon } from "../../../icons"

export const SecurityDialogTitle = () => {
  const userFullName = useSsoService().getFullName()

  return (
    <TitleContainer>
      <SecurityDialogIcon />
      <Box>
        <Title>Accès privé</Title>
        <SubTitle>{userFullName}</SubTitle>
      </Box>
      <Divider flexItem />
    </TitleContainer>
  )
}

const TitleContainer = styled(DialogTitle)(({ theme }) => ({
  padding: `0px ${theme.spacing(9)}`,
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(2),
  alignItems: "center",
  justifyContent: "center",
  marginTop: theme.spacing(3),
  gap: theme.spacing(2),
}))

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.grey.dark,
  fontSize: theme.typography.pxToRem(28),
  textAlign: "center",
}))

const SubTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: theme.typography.pxToRem(18),
  color: theme.palette.primary.main,
  textAlign: "center",
}))
